import classNames from 'classnames/bind';
import styles from '../Dashboard.module.scss';

import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Legend, PolarAngleAxis, RadialBar, RadialBarChart, ResponsiveContainer } from 'recharts';
import { useResponsiveValue } from '~/hooks/useResponsiveValue';
import { IDeviceWarning } from '~/utils/interface/dashboard';

const cx = classNames.bind(styles);

const renderLegend = (fontSize: string, activeLabel: string, warningLabel: string) => {
  return (
    <ul
      style={{
        display: 'flex',
        justifyContent: 'center',
        listStyle: 'none',
        padding: 0,
        gap: '20px',
        fontSize: fontSize,
      }}
    >
      <li>
        <span style={{ color: '#E0E0E0', marginRight: 6 }}>●</span>
        {activeLabel}
      </li>
      <li style={{ marginBottom: 4 }}>
        <span style={{ color: '#ED1002', marginRight: 6 }}>●</span>
        {warningLabel}
      </li>
    </ul>
  );
};

const DevicesSummary = (props: { device_warning?: IDeviceWarning }) => {
  const { t } = useTranslation('admin/home');
  const { device_warning } = props;
  const responsiveFontSize = useResponsiveValue({
    lg: '12px',
    xs: '10px',
    xl: '14px',
  });

  const radiusWidth = useResponsiveValue({
    lg: {
      innerRadius: '100%',
      outerRadius: '160%',
    },
    xl: {
      innerRadius: '160%',
      outerRadius: '100%',
    },
  });

  return (
    <Box className='h-[48%]'>
      <Typography className={cx('dashboard-widget-title', 'dashboard-widget-title-text')}>
        {t('warningDevices')}
      </Typography>
      <Box className={cx('dashboard-widget-body')}>
        <ResponsiveContainer width='100%' height='100%'>
          <RadialBarChart
            cx='50%'
            cy='70%'
            innerRadius={radiusWidth?.innerRadius ?? '120%'}
            outerRadius={radiusWidth?.outerRadius ?? '250%'}
            data={[
              {
                name: t('warningDeviceComponent.warning'),
                value: (Number(device_warning?.warning ?? 0) / Number(device_warning?.total ?? 1)) * 100,
                fill: '#ED1002',
              },
            ]}
            startAngle={180}
            endAngle={0}
          >
            <PolarAngleAxis type='number' domain={[0, 100]} angleAxisId={0} tick={false} />
            <RadialBar background dataKey='value' cornerRadius={10} />
            <text
              x='50%'
              y='60%'
              textAnchor='middle'
              dominantBaseline='middle'
              fill='#ED1002'
              fontSize={20}
              fontWeight='bold'
            >
              {device_warning?.warning ?? 0}
            </text>
            <Legend
              verticalAlign='bottom'
              content={renderLegend(
                responsiveFontSize ?? '10px',
                t('warningDeviceComponent.active'),
                t('warningDeviceComponent.warning')
              )}
            />
          </RadialBarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default memo(DevicesSummary);
